<template>
    <div slot="content">
         
        <!-- 캠페인 합계 s.-->
        <div class="table-area">
            <div class="table-a">
                <el-table
                    :data="campaignSumList"
                    style="width: 100%;">
                    <el-table-column prop="campaignNm" label="캠페인명" align="center" width="260"> </el-table-column>
                    <el-table-column prop="totalCnt" label="총건수" align="center" width="215"> </el-table-column>
                    <el-table-column prop="devideCnt" label="할당건수" align="center" width="215"> </el-table-column>
                    <el-table-column prop="nondevideCnt" label="미할당건수" align="center" width="215"> </el-table-column>
                    <el-table-column prop="doneCnt" label="완료건수" align="center" width="215"> </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 캠페인 합계 e.-->


        <!-- 대상자조회 검색폼 s-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `대상자 조회` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="goBack">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        뒤로가기
                        </button>
                        <button class="btn-size btn-gray fl_left" @click="chkAll">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        전체선택
                        </button>
                        
                        <button class="btn-size btn-gray fl_left" @click="autoWrite">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        체크한 상담원에 자동분배
                        </button>
                        <button class="btn-size btn-gray fl_left" @click="saveCnt">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        저장
                        </button>
                        <button class="btn-size btn-gray fl_left" @click="sendSms">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        문자발송
                        </button>
                        
                    </div>
                </div>
                <el-form ref="form" :model="form" label-width="120px" size="mini">
                    <el-row :gutter="24">
                        <el-col :span="10">
                            <el-form-item label=" ">
                            </el-form-item>
                        </el-col>
                        <el-col :span="14"><!-- 할당/회수 -->
                            <el-radio-group v-model="search.rdType">
                                <el-radio 
                                    v-for="item in combos['rdType']"
                                    :key="item.key"
                                    :label="item.key"
                                    :value="item.value"
                                    @change="changeRdType">{{ item.value }}
                                </el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 상담원 할당/회수 그리드 s.-->
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="subGrid" 
                        :style="subGridStyle"
                        class="ag-theme-alpine"
                        row-selection="single"
                        :column-defs="subColumnDefs"
                        :grid-options="subGridOptions"
                        :row-data="subData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        :stopEditingWhenCellsLoseFocus="true"
                        @grid-ready="onReadySub"
                        @cell-value-changed="CellValueChange"
                        :statusBar="statusBar" />
                </div>
                <!-- 상담원 할당/회수 그리드 e.-->
            </div>
        </div>
        <!-- 대상자조회 검색폼 e -->
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
import DatepickerCellRenderer from '@/components/agGrid/datepicker-cell-renderer';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import RadioCellRenderer from '@/components/agGrid/radio-cell-renderer';
import NumberInputCellRender from '@/components/agGrid/numberinput-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';

/**
 * * Modal
 */


/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            form: {
                campaignStatus: ''
            },
            search: {
                rdType: 'I',
                campaignId: ''
            },
            combos: {
                'campaignStatus': [],
                'rdType': [{key: 'I', value: '할당'}, {key: 'O', value: '회수'}]
            },
            campaignSumList: [
                {
                    campaignNm: '',
                    totalCnt: '',
                    devideCnt: '',
                    nondevideCnt: '',
                    doneCnt: ''
                }
            ], /** 총건수, 할당건수, 미할당건수, 완료건수 */
            data: [],
            subData: [{
                chk: 'N',
                userNm: '',
                userId: '',
                devideCnt: '',
                doneCnt: '',
                nondoneCnt: '',
                recallPossibilityCnt: '',
                cnt: ''
            }],
            subDataOrg: [{
                chk: 'N',
                userNm: '',
                userId: '',
                devideCnt: '',
                doneCnt: '',
                nondoneCnt: '',
                recallPossibilityCnt: '',
                cnt: ''
            }],
            noSaveBut: '',
             
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 160px; min-height:100px;',
            subGridStyle : 'padding-top: 40px; width: 100%;height: 450px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            subColumnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridApi: null,
            subColumnApi: null,
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                maskEdit: MaskEditCellRenderer,
                select: SelectCellRenderer,
                checkBox: CheckboxCellRenderer,
                radio: RadioCellRenderer,
                numberInput: NumberInputCellRender,
                input: InputCellRender,
                button: ButtonCellRenderer,
            },
            statusBar: null,
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        if(this.$route.params.detailLinkYn==='Y'){
            // 상세페이지 클릭하여 페이지이동한 경우

            if(this.$route.params.campaignId===''){
                // campaignId 를 체크
                this.$swal({ type: 'warning', text: '해당 캠페인은 삭제된 캠페인입니다.' });
                return false;

            } else {
                this.search.campaignId = this.$route.params.campaignId;
                this.searchDistribution();
            }
        }

    },
    methods: {
        onReadySub() {
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createSubColumnDefs();
        },
        createSubColumnDefs() {
            const vm = this;
            this.subColumnDefs=[
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    cellRendererParams: (params) => {
                        return {
                            trueValue: 'Y',
                            falseValue: 'N',
                            disable: params.data.userId !='' ? false : true
                        }
                    },
                },
                {
                    headerName:'상담원', 
                    field:'userNm', 
                    width:140,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'상담원', 
                    field:'userId', 
                    width:140,
                    hide: true,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'할당건수', 
                    field:'devideCnt', 
                    width:200,
                    cellStyle : {textAlign: 'right'}
                },
                {
                    headerName: '완료건수', 
                    field:'doneCnt', 
                    width: 200,
                    cellStyle:{textAlign:'right'}
                },
                {
                    headerName: '미완료건수', 
                    field:'nondoneCnt', 
                    width: 200,
                    cellStyle:{textAlign:'right'}
                },
                {
                    headerName: '회수가능건수', 
                    field:'recallPossibilityCnt', 
                    width: 200,
                    cellStyle:{textAlign:'right'}
                },
                {
                    headerName: '건수', 
                    field:'cnt', 
                    width: 200,
                    editable: (params)=>{return params.data.userId !='' ? true : false; },
                    cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'},
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    }
                }
            ]
        },
        onSubCellClicked(params) {
            //const idx = params.rowIndex;
            console.log('onSubCellClicked : ', params)

        },
        goBack(){
            // 리스트 조회화면으로 이동
            this.$router.push({          
                name: 'HappyCallManager',
                params: {
                    searchCond: {
                        ...this.$route.params
                    }
                }
            });
        },
        chkAll(){
            this.subData = 
                this.subData.map(x=>{
                    x.chk = x.chk==='Y' ? 'N' : 'Y';
                    return x;
                });
        },
        autoWrite(){
            // 체크한 상담원에 자동분배
            const vm = this;
            let vMsg = '';
            const vChkObj = this.subData.filter(x=>x.chk==='Y'); 
            
            if(this.noSaveBut === 'NoAuth'){
                vMsg = '분배권한이 없습니다.';
            } else if(this.noSaveBut === 'Complete'){
                vMsg = '캠페인 완료 상태이어서 분배를 할수가 없습니다.';
            } else if(vChkObj && vChkObj.length===0){
                vMsg = '체크박스를 체크해주세요.';
            } else if(this.search.rdType === 'O'){
                vMsg = '회수상태에서는 자동분배하기를 할수 없습니다.';
            }

            if(vMsg !==''){
                this.$swal({ type: 'warning', text: vMsg });
                return false;
            }

            this.$swal({
                type: 'warning',
                text: `자동분배 하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    
                    if(this.campaignSumList[0].nondevideCnt){
                        const vNondevideCnt = Number(this.campaignSumList[0].nondevideCnt); // 미할당건수
                        
                        if(vNondevideCnt===0){
                            this.$swal({ type: 'warning', text: '자동분배할건이 없습니다.' });
                        } else{
                            const vAvg = parseInt(vNondevideCnt / vChkObj.length);
                            const vReMainder = vNondevideCnt % vChkObj.length;
                            let vLoop = 0;

                            // 평균으로 건수칼럼 수정
                            this.subData = this.subData.map(x=>{
                                if(x.chk==='Y'){
                                    const vCnt = vLoop < vReMainder ? vAvg + 1 : vAvg;
                                    if(x.cnt){
                                        x.cnt = Number(x.cnt) + vCnt;
                                    } else {
                                        x.cnt = vCnt;
                                    }
                                    
                                    vLoop++; 
                                }
                                
                                return x;
                            });

                            let vCntSum = 0; // 건수칼럼의 합계
                            this.subData.map(x=>{
                                if(x.cnt){
                                    vCntSum = vCntSum + Number(x.cnt);
                                }
                            });

                            // 할당건수 수정
                            if((this.campaignSumList[0].devideCnt+'') !== 'NaN'){
                                this.campaignSumList[0].devideCnt = Number(this.campaignSumList[0].devideCnt) + vCntSum;
                            }

                            // 미할당건수 수정
                            if((this.campaignSumList[0].nondevideCnt+'') !== 'NaN'){
                                this.campaignSumList[0].nondevideCnt = Number(this.campaignSumList[0].nondevideCnt) - vCntSum;
                            }
                        }

                    } else {
                        this.$swal({ type: 'warning', text: '자동분배할건이 없습니다.' });
                    }
                }
            });

        },
        saveCnt(){
            /** 저장처리 */

            let vMsg = '';
            if(this.noSaveBut === 'NoAuth'){
                vMsg = '분배권한이 없습니다.';
            } else if(this.noSaveBut === 'Complete'){
                vMsg = '캠페인 완료 상태이어서 분배를 할수가 없습니다.';
            } 

            if(vMsg !==''){
                this.$swal({ type: 'warning', text: vMsg });
                return false;
            }

            const vm = this;
            const vCampaignCustStatus = '';

            let vCntSum = 0;
            console.log('this.subData : ', this.subData);
            const vSubData = this.subData.filter(x=>x.chk==='Y');
            if(vSubData && vSubData.length===0){
                this.$swal({ type: 'warning', text: '변경할 항목을 선택해 주세요.' })
                return false;
            }

            vSubData.map(x=>{
                if(x.cnt){
                    const vcnt = x.cnt;
                    if((vcnt+'') !== 'NaN'){
                        vCntSum += Number(vcnt);
                    }
                }
                
                return x;
            });

            if(this.search.rdType === ''){
                this.$swal({ type: 'warning', text: '할당 혹은 회수를 선택하세요.' })
                return false;

            } else if(this.search.rdType === 'I'){
                if(vCntSum < 1) 
                {
                    this.$swal({ type: 'warning', text: '할당 건수를 입력후 저장하세요.' })
                    return false;
                }
            } else {
                if(vCntSum < 1) 
                {
                    this.$swal({ type: 'warning', text: '회수 건수를 입력후 저장하세요.' })
                    return false;
                }
            }

           
            this.$swal({
                type: 'warning',
                text: `저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    
                    const vform = {
                        campaignId: vm.search.campaignId,
                        distType: vm.search.rdType,
                        distribCntList: vSubData
                    }
                    
                    console.log('save ...vform: ', vform)             
                    vm.$store.commit('loading');
                    vm.$http.put(_url("/api/workMng/happyCallManager/saveDistribCnt"), vform)
                        .then(response => {
                            const vMsg = response.data;
console.log('saveDistribCnt  response.data : ',  response.data)
                            vm.$swal({ type: 'success', text: vMsg });
                            vm.searchDistribution();
                        }).catch((e) => {
                            // console.error(e);
                            // vm.$swal({ type: 'success', text: '처리결과 저장에 실패했습니다' })
                        })
                        .finally(() => {
                            vm.$store.commit('finish');
                        });
                }
            });
        },
        sendSms(){
            const vm = this;

            this.$swal({
                type: 'warning',
                text: `문자를 발송하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    
                    const vform = {
                        campaignId: vm.search.campaignId
                    }
                    
                    console.log('save ...vform: ', vform)             
                    vm.$store.commit('loading');
                    vm.$http.put(_url("/api/workMng/happyCallManager/sendSms"), vform)
                        .then(response => {
                            const vMsg = response.data;
                            console.log('sendSms  response.data : ',  response.data)
                            
                            if(vMsg == 'FAIL'){
                                vm.$swal({ type: 'success', text: '이미 문자가 발송되었습니다.' });
                            } else {
                                vm.$swal({ type: 'success', text: '정상적으로 문자가 발송되었습니다.' });
                            }
                        }).catch((e) => {
                            // console.error(e);
                            
                        })
                        .finally(() => {
                            vm.$store.commit('finish');
                        });
                }
            });
        },
        enableChk(param){
            /** 입력항목 활성화처리 */
            console.log('enableChk start :', param);
            if(param === 'IN_CALL_ID'){
                if(this.form.callType === 'Processing'){
                    // 처리결과가 미완료이면 수정가능해야 함.
                    this.bReadOnly = false;
                } else {
                    this.bReadOnly = true;
                }
                
            } else {
                this.bReadOnly = false;
            }
        },
        CellValueChange(params){
            const idx = params.rowIndex;
            const field = params.colDef.field;

            if(field==='cnt'){
                
                console.log('onCellClicked params.data ',this.search.rdType,  params.data)
                
                const vTotalCnt = this.campaignSumList[0].totalCnt || 0; // 총건수
                const vDevideCnt = this.campaignSumList[0].devideCnt || 0; // 할당건수
                const vNondevideCnt = this.campaignSumList[0].nondevideCnt || 0; // 미할당건수
                const vDoneCnt = this.campaignSumList[0].doneCnt || 0; // 완료건수
                let vInputSum = 0;
                
                this.subData.map(x=>{
                    if(x.cnt){
                        const vcnt = x.cnt;
                        if((vcnt+'') !== 'NaN'){
                            vInputSum += Number(vcnt);
                        }
                    }
                })

                let vInitYn = 'N';
                let vMsg = '';
                
                if(this.search.rdType === 'I'){
                    // 할당이면

                    if(vNondevideCnt == 0){
                        // 미할당건수 합이 0인데 사용자가 입력할려고 하면 초기화
                        vInitYn = 'Y';
                        vMsg = '할당가능 총수량은 ' + vNondevideCnt + '건 입니다.';
                    } else if(vInputSum > Number(vNondevideCnt)){
                        // 입력값의 합이 미할당건수의 합보다 크면 초기화
                        vInitYn = 'Y';

                        vMsg = '할당가능 총수량은 ' + vNondevideCnt + '건 입니다.';
                    }

                } else if(this.search.rdType === 'O'){
                    // 회수이면

                    let vcnt = params.data.cnt;
                    if((vcnt+'') === 'NaN'){
                        vcnt = 0
                    }
                    
                    if(params.data.recallPossibilityCnt == 0){
                        // 회수가능건수가 0이면 사용자가 입력한 값 초기화
                        vInitYn = 'Y';
                        vMsg = '회수가능 총수량은 0건 입니다.';

                    } else if(vcnt > params.data.recallPossibilityCnt){
                        // 회수가능건수가 0이면 사용자가 입력한 값 초기화
                        vInitYn = 'Y';
                        vMsg = '회수가능 총수량은 ' + vNondevideCnt + '건 입니다.';
                    }
                    console.log('회수일때 체크 : ', vcnt, params.data.recallPossibilityCnt);

                }

                if(vInitYn === 'Y'){
                    const chgObj = JSON.parse(JSON.stringify(this.subData));
                    this.subData = chgObj.map((x,index)=>{
                        if(index === idx){
                            x['cnt'] = 0;
                        }

                        return x;
                    });
                }
                
                if(vMsg !==''){
                    this.$swal({ type: 'warning', text: vMsg });
                }
            }

        },
        changeRdType(){
            // 할당/회수 라디오버튼 변경시

            console.log('changeRdType start===');

            // 조회시의 데이타로 원복
            const chgObj = JSON.parse(JSON.stringify(this.subDataOrg));
            this.subData = chgObj;

        },
        searchDistribution(){
            /** 분배 조회 */
            
            const vform = {
                campaignId: this.$route.params.campaignId,
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            
            this.$store.commit('loading')
            console.log('searchCust vform : ', vform) 
            this.$http.post(("/api/workMng/happyCallManager/selectDistribUser"), vform
                ).then(response => {
                 console.log('searchDistribution response.data' , response.data)

                 const vFormObj = response.data.uspCampaignSelItem;

                 if(vFormObj && vFormObj.length>0){
                    this.campaignSumList  = 
                        [
                            {
                                campaignNm: vFormObj[0].campaignNm, 
                                totalCnt: vFormObj[0].totalCnt,
                                devideCnt: vFormObj[0].devideCnt,
                                nondevideCnt: vFormObj[0].nondevideCnt,
                                doneCnt: vFormObj[0].doneCnt
                            }
                        ];

                        console.log(' dddsss  vFormObj[0].campaignStatus: ', vFormObj[0].campaignStatus)
                    this.form = vFormObj[0] || {};

                    if(this.isAuth()){
                        if(vFormObj[0].campaignStatus === 'Complete'){
                            this.noSaveBut = vFormObj[0].campaignStatus;
                        }
                    } else {
                        this.noSaveBut = 'NoAuth';
                    }
                 }
                 
                 this.subData = response.data.uspCampaignCustSelDistripUser.map(x=>{
                    x.chk = 'N';

                    return x;
                 });

                 this.subDataOrg = _.cloneDeep(this.subData); // 조회 데이타 백업
                
            }).finally(() => {
                this.$store.commit('finish')

                
            });
        },
        isAuth(){
            const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===108); // 해피콜관리(상담원분배)
            let GrantInsert = false // 입력권한
            if(auth && auth.length > 0){
                GrantInsert = auth[0].grantInsert === 'Y' ? true : false   
            }

            if(!GrantInsert){
            //    this.$swal({ type: 'warning', text: '입력권한이 없습니다.' });
                return false;
            }

            return true;
        }
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>